import { BaseQueryParams } from "../../../../Components/Core/BasePage/BaseQueryParams";
export class QueryParams extends BaseQueryParams
{
    public status?: string;
    public classification?: string;
    public supplier?: string;
    public filter?: string;
    public orderPolicy?:string
}